import {useLayoutEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {resetPageScroll} from '../../utils/resetPageScroll';

export default function RouteScrollReset(){
  const {pathname,search}=useLocation();
  useLayoutEffect(()=>resetPageScroll(),[pathname,search]);
  return null;
}
